"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIDialogButton;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _decorators = require("../utils/propTypes/decorators");

var _componentProp = require("../utils/propTypes/componentProp");

var _iconName = require("../utils/propTypes/iconName");

var _Color = require("../core/Color");

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _Styles = require("../utils/Styles");

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var _UIIconHolder = _interopRequireDefault(require("../icon/UIIconHolder"));

var DialogButton = (0, _styledComponents.default)(function (_ref) {
  var __hovered = _ref.hovered,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["hovered"]);
  return _react.default.createElement(_UIClickable.default, rest);
}).attrs({
  className: 'private-modal__control'
}).withConfig({
  displayName: "UIDialogButton__DialogButton",
  componentId: "sc-1gd0bn1-0"
})(["", ";align-items:center;color:", ";display:flex;flex-shrink:0;justify-content:center;height:", ";line-height:normal;position:relative;width:", ";z-index:", ";&::after{", ";background:", ";border-radius:100%;content:' ';left:50%;padding:20px;position:absolute;top:50%;transform:translate(-50%,-50%);}&[aria-disabled='true']{cursor:not-allowed;opacity:0.6;}"], (0, _Styles.setUiTransition)('color'), _colors.OLAF, _sizes.MODAL_CLOSE_BUTTON_SIZE, _sizes.MODAL_CLOSE_BUTTON_SIZE, _sizes.MERCURY_LAYER, (0, _Styles.setUiTransition)('background'), function (props) {
  return props.hovered && (0, _Color.rgba)(_colors.OLAF, 0.1);
}); // fix for IE11 misaligning icons when using UIIconHolder:
// https://git.hubteam.com/HubSpot/UIComponents/issues/5105

var ICON_STYLES = {
  marginLeft: 'auto',
  marginRight: 'auto'
};

function UIDialogButton(props) {
  var IconHolder = props.IconHolder,
      iconName = props.iconName,
      iconSize = props.iconSize,
      rest = (0, _objectWithoutProperties2.default)(props, ["IconHolder", "iconName", "iconSize"]);
  return _react.default.createElement(_HoverProvider.default, props, function (hoverProviderProps) {
    return _react.default.createElement(DialogButton, Object.assign({}, rest, hoverProviderProps), _react.default.createElement(IconHolder, {
      innerStyles: ICON_STYLES,
      name: iconName,
      padding: 0,
      size: iconSize
    }));
  });
}

UIDialogButton.propTypes = {
  'aria-label': _propTypes.default.string.isRequired,
  hovered: (0, _decorators.hidden)(_propTypes.default.bool),
  IconHolder: (0, _componentProp.getComponentPropType)(_UIIconHolder.default),
  iconName: (0, _iconName.getIconNamePropType)(),
  iconSize: _UIIconHolder.default.propTypes.size
};
UIDialogButton.defaultProps = {
  IconHolder: _UIIconHolder.default,
  iconSize: 'xxs'
};
UIDialogButton.displayName = 'UIDialogButton';
module.exports = exports.default;